/** Uma pagina de resultado, e a janela de botoes que a representa. */
/**
 * As paginas que um paginador oferece: cinco, centradas na atual.
 *
 * Funcao pura de `page` e `pageCount`, os dois valores que todo scope paginado ja
 * publica. Estava na view, com o argumento de que "e pura" - que e o argumento
 * invertido: sendo pura e conceitual, e justamente o que outra renderizacao
 * reaproveita em vez de reescrever.
 */
export function pageWindow(page, pageCount) {
    const maxSize = 5;
    let start = Math.max(1, page - 2);
    const end = Math.min(pageCount, start + maxSize - 1);
    if (end - start + 1 < maxSize) {
        start = Math.max(1, end - maxSize + 1);
    }
    const pages = [];
    for (let i = start; i <= end; i++) {
        pages.push(i);
    }
    return pages;
}
//# sourceMappingURL=paging.js.map